import { render, staticRenderFns } from "./molisDataStatistic.vue?vue&type=template&id=a8ece3c8&scoped=true"
import script from "./molisDataStatistic.vue?vue&type=script&lang=ts"
export * from "./molisDataStatistic.vue?vue&type=script&lang=ts"
import style0 from "./molisDataStatistic.vue?vue&type=style&index=0&id=a8ece3c8&prod&lang=stylus&scoped=true"
import style1 from "./molisDataStatistic.vue?vue&type=style&index=1&id=a8ece3c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ece3c8",
  null
  
)

export default component.exports